module.exports = __webpack_public_path__ + "img/headset.87bfa001.svg";